<template>
  <div>
    <div class="page-header">
      <div>
        <div class="page-title">代理管理</div>
        <div class="page-subtitle">代理账户信息管理</div>
      </div>
      <el-button type="primary" @click="openCreateDialog">新增代理</el-button>
    </div>
    <el-card>
      <el-form class="table-filters" inline size="small">
        <el-form-item label="账号">
          <el-input v-model="filters.username" placeholder="输入账号关键词" clearable />
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="filters.status" placeholder="全部" clearable>
            <el-option label="启用" value="1" />
            <el-option label="禁用" value="0" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="agents" stripe @sort-change="handleSortChange">
        <el-table-column prop="id" label="ID" width="80" sortable="custom" />
        <el-table-column prop="username" label="账号" min-width="160" sortable="custom">
          <template slot-scope="scope">
            <span @click="copyAccount(scope.row.username)">{{ scope.row.username }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="money" label="余额" min-width="180" sortable="custom" />
        <el-table-column prop="fee" label="手续费（%）" min-width="180" sortable="custom" />
        <!-- <el-table-column prop="email" label="邮箱" min-width="180" sortable="custom" /> -->
        <el-table-column prop="created_at" label="创建时间" width="170" sortable="custom" />
        <el-table-column prop="updated_at" label="更新时间" width="170" sortable="custom" />
        <el-table-column prop="account_balance" label="待结算金额" width="170" sortable="custom" />
        <el-table-column label="状态" width="120" prop="status" sortable="custom">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.status" :active-value="1" :inactive-value="0" active-color="#13ce66"
              inactive-color="#dcdfe6" @change="handleStatusChange(scope.row)" />
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button type="text" @click="openEditDialog(scope.row)">编辑</el-button>
            <el-button type="text" @click="openResetDialog(scope.row)">修改密码</el-button>
            <el-button type="text" @click="confirmDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="table-pagination">
        <el-pagination background layout="total, sizes, prev, pager, next, jumper" :current-page="pagination.page"
          :page-size="pagination.limit" :page-sizes="[10, 20, 50, 100]" :total="pagination.total"
          @current-change="handlePageChange" @size-change="handleSizeChange" />
      </div>
    </el-card>

    <el-dialog title="修改密码" :visible.sync="resetDialogVisible" width="500px">
      <el-form label-width="80px">
        <el-form-item label="账号">
          <el-input v-model="resetForm.username" disabled />
        </el-form-item>
        <el-form-item label="新密码">
          <el-input v-model="resetForm.password" type="password" placeholder="请输入新密码（至少6位）" />
          <el-button size="mini" type="primary" @click="generateRandomPassword"
            style="margin-top: 10px;">生成随机密码</el-button>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="resetDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmReset">确认</el-button>
      </div>
    </el-dialog>

    <el-dialog title="新增代理" :visible.sync="createDialogVisible" width="360px">
      <el-form label-width="80px">
        <el-form-item label="账号">
          <el-input v-model="createForm.username" placeholder="请输入账号（至少6位）" />
        </el-form-item>
        <el-form-item label="密码">
          <el-input v-model="createForm.password" type="password" placeholder="请输入密码（至少6位）" />
        </el-form-item>
        <el-form-item label="状态">
          <el-switch v-model="createForm.status" :active-value="1" :inactive-value="0" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="createDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmCreate">提交</el-button>
      </div>
    </el-dialog>
    
    <el-dialog title="编辑代理信息" :visible.sync="editDialogVisible" width="500px">
      <el-form label-width="80px">
        <el-form-item label="账号">
          <el-input v-model="editForm.username" disabled />
        </el-form-item>
        <el-form-item label="当前余额">
          <el-input v-model="editForm.currentMoney" disabled />
        </el-form-item>
        <el-form-item label="余额操作">
          <el-radio-group v-model="editForm.operationType">
            <el-radio label="add">增加</el-radio>
            <el-radio label="subtract">减少</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="操作金额">
          <el-input v-model="editForm.amount" type="number" placeholder="请输入金额" />
        </el-form-item>
        <el-form-item label="手续费">
          <el-input v-model="editForm.fee" type="number" placeholder="请输入手续费" />
        </el-form-item>
        <el-form-item label="金额操作备注">
          <el-input v-model="editForm.remark" type="textarea" placeholder="请输入备注信息" :rows="3" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="editDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmEdit">确认修改</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 维护本地状态，避免直接修改props
      localGoods: [],
      resetDialogVisible: false,
      resetForm: {
        id: "",
        username: "",
        password: ""
      },
      createDialogVisible: false,
      createForm: {
        username: "",
        password: "",
        status: 1
      },
      editDialogVisible: false,
      editForm: {
        id: "",
        username: "",
        currentMoney: "",
        operationType: "add",
        amount: "",
        fee: "",
        remark: ""
      },
      filters: {
        username: "",
        status: ""
      },
      sort: {
        field: "id",
        order: "desc"
      },
      pagination: {
        page: 1,
        limit: 10,
        total: 0
      },
      agents: []
    };
  },
  computed: {},
  // 页面挂载完成
  mounted() { },
  // 页面创建完成
  created() {
    // 初始化拉取列表
    this.getAgents();
  },
  methods: {
    // 生成随机密码（8位大写+数字）
    generateRandomPassword() {
      const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
      let password = "";
      for (let i = 0; i < 8; i++) {
        password += characters.charAt(Math.floor(Math.random() * characters.length));
      }
      this.resetForm.password = password;
      this.$message.success("已生成随机密码");
    },
    // 复制账号
    copyAccount(account) {
      this.$copy(account).then(() => {
        this.$message.success("已复制账号");
      }).catch(() => {
        this.$message.error("复制失败");
      });
    },
    // 获取代理列表 
    getAgents() {
      const query = this.buildQuery({
        page: this.pagination.page,
        limit: this.pagination.limit,
        username: this.filters.username,
        status: this.filters.status,
        sort_field: this.sort.field,
        sort_order: this.sort.order
      });
      this.$http_get(`/admin/agent/all?${query}`, 1).then(res => {
        if (res && res.code === 200 && res.data) {
          const list = Array.isArray(res.data.data) ? res.data.data : [];
          this.agents = this.mapAgents(list);
          this.pagination.total = Number(res.data.total || 0);
          this.pagination.page = Number(res.data.current_page || this.pagination.page);
          this.pagination.limit = Number(res.data.per_page || this.pagination.limit);
        }
      });
    },
    // 拼接查询参数
    buildQuery(params) {
      return Object.keys(params)
        .filter(key => params[key] !== "" && params[key] !== null && params[key] !== undefined)
        .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
        .join("&");
    },
    // 映射接口数据到表格字段
    mapAgents(list) {
      return list.map(item => {
        return {
          ...item,
          status: Number(item.status) === 1 ? 1 : 0
        };
      });
    },
    // 查询列表
    handleSearch() {
      this.pagination.page = 1;
      this.getAgents();
    },
    // 重置筛选
    handleReset() {
      this.filters.username = "";
      this.filters.status = "";
      this.sort.field = "id";
      this.sort.order = "desc";
      this.pagination.page = 1;
      this.getAgents();
    },
    // 切换排序
    handleSortChange({ prop, order }) {
      const fieldMap = {
        id: "id",
        username: "username",
        email: "email",
        created_at: "created_at",
        updated_at: "updated_at",
        status: "status"
      };
      this.sort.field = fieldMap[prop] || "id";
      if (order === "ascending") {
        this.sort.order = "asc";
      } else if (order === "descending") {
        this.sort.order = "desc";
      } else {
        this.sort.order = "desc";
      }
      this.pagination.page = 1;
      this.getAgents();
    },
    // 切换页码
    handlePageChange(page) {
      this.pagination.page = page;
      this.getAgents();
    },
    // 切换每页条数
    handleSizeChange(size) {
      this.pagination.limit = size;
      this.pagination.page = 1;
      this.getAgents();
    },
    // 打开新增弹窗
    openCreateDialog() {
      this.createForm.username = "";
      this.createForm.password = "";
      this.createForm.status = 1;
      this.createDialogVisible = true;
    },
    // 确认新增
    confirmCreate() {
      if (!this.createForm.username || !this.createForm.password) {
        this.$message.warning("请输入账号和密码");
        return;
      }
      if (this.createForm.username.length < 6 || this.createForm.password.length < 6) {
        this.$message.warning("账号和密码长度需不少于6位");
        return;
      }
      const payload = {
        username: this.createForm.username,
        password: this.createForm.password,
        status: this.createForm.status
      };
      this.$http_post("/admin/agent/create", payload, 1).then(res => {
        if (res && res.code === 200) {
          this.createDialogVisible = false;
          this.pagination.page = 1;
          this.getAgents();
        }
      });
    },
    // 打开重置密码弹窗
    openResetDialog(row) {
      this.resetForm.id = row.id;
      this.resetForm.username = row.username;
      this.resetForm.password = "";
      this.resetDialogVisible = true;
    },
    // 确认重置密码
    confirmReset() {
      if (!this.resetForm.password) {
        this.$message.warning("请输入新密码");
        return;
      }
      if (this.resetForm.password.length < 6) {
        this.$message.warning("密码长度需不少于6位");
        return;
      }
      this.$http_post("/admin/agent/reset_password", {
        id: this.resetForm.id,
        password: this.resetForm.password
      }, 1).then(res => {
        if (res && res.code === 200) {
          this.resetDialogVisible = false;
          this.resetForm.password = "";
        }
      });
    },
    // 删除代理账号
    confirmDelete(row) {
      this.$confirm(`确认删除账号 ${row.username} 吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$http_post("/admin/agent/delete", { id: row.id }, 1).then(res => {
          if (res && res.code === 200) {
            if (this.agents.length === 1 && this.pagination.page > 1) {
              this.pagination.page -= 1;
            }
            this.getAgents();
          }
        });
      }).catch(() => { });
    },
    // 修改账号状态
    handleStatusChange(row) {
      const nextStatus = Number(row.status) === 1 ? 1 : 0;
      this.$http_post("/admin/agent/set_status", { id: row.id, status: nextStatus }, 1).then(res => {
        if (!res || res.code !== 200) {
          row.status = nextStatus === 1 ? 0 : 1;
        }
      });
    },
    // 打开编辑弹窗
    openEditDialog(row) {
      this.editForm.id = row.id;
      this.editForm.username = row.username;
      this.editForm.currentMoney = row.money;
      this.editForm.operationType = "add";
      this.editForm.amount = "";
      this.editForm.fee = row.fee;
      this.editForm.remark = "";
      this.editDialogVisible = true;
    },
    // 确认编辑
    confirmEdit() {
      if (!this.editForm.amount && this.editForm.amount !== 0) {
        this.$message.warning("请输入操作金额");
        return;
      }
      if (!this.editForm.fee && this.editForm.fee !== 0) {
        this.$message.warning("请输入手续费");
        return;
      }
      const amount = Number(this.editForm.amount);
      const fee = Number(this.editForm.fee);
      if (isNaN(amount)) {
        this.$message.warning("操作金额必须是数字");
        return;
      }
      if (isNaN(fee)) {
        this.$message.warning("手续费必须是数字");
        return;
      }
      if (amount < 0) {
        this.$message.warning("操作金额不能为负数");
        return;
      }
      if (fee < 0) {
        this.$message.warning("手续费不能为负数");
        return;
      }
      if (this.editForm.remark && this.editForm.remark.length > 200) {
        this.$message.warning("备注信息不能超过200个字符");
        return;
      }
      this.$http_post("/admin/agent/update", {
        id: this.editForm.id,
        operationType: this.editForm.operationType,
        amount: amount,
        fee: fee,
        remark: this.editForm.remark
      }, 1).then(res => {
        if (res && res.code === 200) {
          this.editDialogVisible = false;
          this.getAgents();
        } else {
          this.$message.error(res.msg || "修改失败");
        }
      }).catch(err => {
        this.$message.error("网络错误");
        console.error("修改代理信息失败:", err);
      });
    }
  }
};
</script>

<style>
.table-filters {
  margin-bottom: 12px;
}

.table-pagination {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
}
</style>
